import {
  coursePrice,
  issuePrice,
  monthPrice,
  annualPrice,
  trialPrice,
  foreverPrice,
  MONTH,
  YEAR,
  FOREVER,
  TRIAL,
  courseFirstTimePrice
} from '../../components/utils/stripePrices'

export const appPrices = [
  {
    id: coursePrice,
    interval: '',
    type: 'course'
  },
  {
    id: courseFirstTimePrice,
    interval: '',
    type: 'course'
  },
  {
    id: issuePrice,
    interval: '',
    type: 'issue'
  },
  {
    id: monthPrice,
    interval: MONTH,
    type: 'subscription'
  },
  {
    id: annualPrice,
    interval: YEAR,
    type: 'subscription'
  },
  {
    id: trialPrice,
    interval: TRIAL,
    type: 'subscription'
  },
  {
    id: foreverPrice,
    interval: FOREVER,
    type: 'subscription'
  }
]
